import { render, staticRenderFns } from "./InterfaceSettingsNavigation.vue?vue&type=template&id=5e8d92d2&scoped=true"
import script from "./InterfaceSettingsNavigation.vue?vue&type=script&lang=js"
export * from "./InterfaceSettingsNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8d92d2",
  null
  
)

export default component.exports